export const EMOTIONS = [
  { id: "alegria", name: "Alegría", color: "#F1C75B", nuances: ["serenidad", "alegría", "éxtasis"] },
  { id: "confianza", name: "Confianza", color: "#A9C97E", nuances: ["aceptación", "confianza", "admiración"] },
  { id: "miedo", name: "Miedo", color: "#5FA383", nuances: ["temor", "miedo", "terror"] },
  { id: "sorpresa", name: "Sorpresa", color: "#7CC3DA", nuances: ["distracción", "sorpresa", "asombro"] },
  { id: "tristeza", name: "Tristeza", color: "#7B9BC9", nuances: ["melancolía", "tristeza", "pena"] },
  { id: "aversion", name: "Aversión", color: "#A98CC2", nuances: ["aburrimiento", "aversión", "repugnancia"] },
  { id: "ira", name: "Ira", color: "#E07A5F", nuances: ["enojo", "ira", "furia"] },
  { id: "anticipacion", name: "Anticipación", color: "#EE9D55", nuances: ["interés", "anticipación", "vigilancia"] },
];

export const EMOTION_COLORS = Object.fromEntries(EMOTIONS.map((e) => [e.id, e.color]));

// moods are stored as "emocion" or "emocion:matiz"
export const moodEmotion = (mood) => mood.split(":")[0];
export const moodColor = (mood) => EMOTION_COLORS[moodEmotion(mood)];
export const moodLabel = (mood) => mood.split(":").pop();

export const countWords = (text) => (text.trim() ? text.trim().split(/\s+/).length : 0);
